import React, { useEffect, useRef, useState } from 'react';
import FastFillSettings from './settings/fast-fill-settings';

export default function FastFillSettingsHost() {
  const [open, setOpen] = useState(false);
  const modalOpenRef = useRef(false);

  useEffect(() => {
    const fastFillSettingsButton = document.getElementById('fast-fill-settings');
    if (!fastFillSettingsButton) {
      return undefined;
    }

    const handleOpen = (event: Event) => {
      event.preventDefault();
      setOpen(true);
      modalOpenRef.current = true;
      const bridge = window.FormBuilderReactBridge;
      if (bridge && typeof bridge.notifyModalStateChange === 'function') {
        bridge.notifyModalStateChange(true);
      }
    };

    fastFillSettingsButton.addEventListener('click', handleOpen);

    return () => {
      fastFillSettingsButton.removeEventListener('click', handleOpen);
      if (modalOpenRef.current) {
        const bridge = window.FormBuilderReactBridge;
        if (bridge && typeof bridge.notifyModalStateChange === 'function') {
          bridge.notifyModalStateChange(false);
        }
      }
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
    modalOpenRef.current = false;
    const bridge = window.FormBuilderReactBridge;
    if (bridge && typeof bridge.notifyModalStateChange === 'function') {
      bridge.notifyModalStateChange(false);
    }
  };

  return (
    <FastFillSettings open={open} onClose={handleClose} />
  );
}
